import { createSlice, createAction } from '@reduxjs/toolkit';

// --- Toggle Carousel Status Actions ---
export const toggleCarouselStatusRequest = createAction('carousel/toggleStatusRequest');
export const toggleCarouselStatusSuccess = createAction('carousel/toggleStatusSuccess');
export const toggleCarouselStatusFailure = createAction('carousel/toggleStatusFailure');

// --- Delete Carousel Actions ---
export const deleteCarouselRequest = createAction('carousel/deleteRequest');
export const deleteCarouselSuccess = createAction('carousel/deleteSuccess');
export const deleteCarouselFailure = createAction('carousel/deleteFailure');

// --- Add / Delete Location Actions ---
export const addCarouselLocationRequest = createAction('carousel/addLocationRequest');
export const addCarouselLocationSuccess = createAction('carousel/addLocationSuccess');
export const addCarouselLocationFailure = createAction('carousel/addLocationFailure');

export const deleteCarouselLocationRequest = createAction('carousel/deleteLocationRequest');
export const deleteCarouselLocationSuccess = createAction('carousel/deleteLocationSuccess');
export const deleteCarouselLocationFailure = createAction('carousel/deleteLocationFailure');

// --- Delete Slide Actions ---
export const deleteSlideRequest = createAction('carousel/deleteSlideRequest');
export const deleteSlideSuccess = createAction('carousel/deleteSlideSuccess');
export const deleteSlideFailure = createAction('carousel/deleteSlideFailure');

const initialState = {
  data: [],
  loading: false,
  error: null,
  message: '',

  singleCarousel: null,
  singleLoading: false,
  singleError: null,

  toggleStatusSuccess: false,
  toggleStatusFailure: false,

  deleteLoading: false,
  deleteSuccess: false,
  deleteFailure: false,

  deleteSlideLoading: false,
  deleteSlideSuccess: false,
  deleteSlideFailure: false,

  locationActionLoading: false,
};

const carouselSlice = createSlice({
  name: 'carousel',
  initialState,
  reducers: {
    fetchCarouselRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchCarouselSuccess: (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.message = 'Carousel list fetched successfully';
    },
    fetchCarouselFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    fetchSingleCarouselRequest: (state) => {
      state.singleLoading = true;
      state.singleError = null;
    },
    fetchSingleCarouselSuccess: (state, action) => {
      state.singleLoading = false;
      state.singleCarousel = action.payload;
    },
    fetchSingleCarouselFailure: (state, action) => {
      state.singleLoading = false;
      state.singleError = action.payload;
    },

    resetToggleStatusFlags: (state) => {
      state.toggleStatusSuccess = false;
      state.toggleStatusFailure = false;
    },

    resetDeleteFlags: (state) => {
      state.deleteSuccess = false;
      state.deleteFailure = false;
    },

    clearLoading: (state) => {
      state.loadingSlideId = null;
    }
  },
  extraReducers: (builder) => {
    // Toggle slide status
    builder
      .addCase(toggleCarouselStatusRequest, (state) => {
        state.loading = true;
        state.toggleStatusSuccess = false;
        state.toggleStatusFailure = false;
      })
      .addCase(toggleCarouselStatusSuccess, (state) => {
        state.loading = false;
        state.toggleStatusSuccess = true;
      })
      .addCase(toggleCarouselStatusFailure, (state) => {
        state.loading = false;
        state.toggleStatusFailure = true;
      })

      // Delete full carousel
      .addCase(deleteCarouselRequest, (state) => {
        state.deleteLoading = true;
        state.deleteSuccess = false;
        state.deleteFailure = false;
      })
      .addCase(deleteCarouselSuccess, (state, action) => {
        state.deleteLoading = false;
        state.deleteSuccess = true;
        // state.data = state?.data?.filter(item => item._id !== action.payload);
      })
      .addCase(deleteCarouselFailure, (state, action) => {
        state.deleteLoading = false;
        state.deleteFailure = true;
        state.error = action.payload;
      })

      // Delete slide
      .addCase(deleteSlideRequest, (state) => {
        state.deleteSlideLoading = true;
        state.deleteSlideSuccess = false;
        state.deleteSlideFailure = false;
      })
      .addCase(deleteSlideSuccess, (state, action) => {
        state.deleteSlideLoading = false;
        state.deleteSlideSuccess = true;
        if (state.singleCarousel && state.singleCarousel.slides) {
          state.singleCarousel.slides = state.singleCarousel.slides.filter(slide => slide._id !== action.payload);
        }
      })
      .addCase(deleteSlideFailure, (state, action) => {
        state.deleteSlideLoading = false;
        state.deleteSlideFailure = true;
        state.error = action.payload;
      })

      // Add location
      .addCase(addCarouselLocationRequest, (state) => {
        state.locationActionLoading = true;
      })
      .addCase(addCarouselLocationSuccess, (state) => {
        state.locationActionLoading = false;
      })
      .addCase(addCarouselLocationFailure, (state, action) => {
        state.locationActionLoading = false;
        state.error = action.payload;
      })

      // Delete location
      .addCase(deleteCarouselLocationRequest, (state) => {
        state.locationActionLoading = true;
      })
      .addCase(deleteCarouselLocationSuccess, (state) => {
        state.locationActionLoading = false;
      })
      .addCase(deleteCarouselLocationFailure, (state, action) => {
        state.locationActionLoading = false;
        state.error = action.payload;
      });
  }
});

export const {
  fetchCarouselRequest,
  fetchCarouselSuccess,
  fetchCarouselFailure,
  fetchSingleCarouselRequest,
  fetchSingleCarouselSuccess,
  fetchSingleCarouselFailure,
  resetToggleStatusFlags,
  resetDeleteFlags,
  clearLoading
} = carouselSlice.actions;

export default carouselSlice.reducer;
